import { useEffect, useState } from 'react';
import type { Room } from 'colyseus.js';
import { colyseusClient } from '../../api/colyseus.js';

/**
 * Reusable Online Status component showing real connected players in the lobby room.
 */
export function OnlineStatus() {
  const [playersOnline, setPlayersOnline] = useState(1);

  useEffect(() => {
    let activeRoom: Room | null = null;
    let isMounted = true;

    async function connectToLobby() {
      try {
        const room = await colyseusClient.joinOrCreate('lobby');
        if (!isMounted) {
          room.leave();
          return;
        }
        activeRoom = room;

        room.onMessage('online-count', (message: { count: number }) => {
          if (isMounted) {
            setPlayersOnline(message.count);
          }
        });
      } catch (err) {
        console.error('Failed to connect to Colyseus lobby:', err);
      }
    }

    connectToLobby();

    return () => {
      isMounted = false;
      if (activeRoom) {
        activeRoom.leave();
      }
    };
  }, []);

  return (
    <div className="flex items-center space-x-2 px-3 py-1.5 rounded-full bg-emerald-500/5 border border-emerald-500/10 shadow-inner select-none pointer-events-none">
      {/* Green pulsing indicator */}
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
      </span>
      <span className="text-[10px] font-bold font-mono tracking-wider uppercase text-emerald-400/90">
        {playersOnline.toLocaleString()} Players Online
      </span>
    </div>
  );
}
